import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Container } from './Container';
export function Footer() {
  return <footer className="bg-[#111827] text-gray-300 pt-16 pb-8 border-t-4 border-pts-red" data-id="element-23">
      <Container data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-25">
          {/* Brand & Contact */}
          <div className="space-y-6" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/gWFT4ncmNMgwJGpFpp5fGQ/PTS-logo-clean-black-transparent.png" alt="Primetime Sports Apparel" className="h-12 w-auto brightness-0 invert" data-id="element-27" />
            <p className="text-sm text-gray-400" data-id="element-28">
              Custom Team Uniforms Without the Ordering Stress. Factory-direct
              quality, unbeatable pricing, and dedicated support.
            </p>
            <div className="space-y-3 text-sm" data-id="element-29">
              <div className="flex items-start" data-id="element-30">
                <MapPin className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-31" />
                <span data-id="element-32">
                  9229 Southampton Place
                  <br data-id="element-33" />
                  Boca Raton, Florida 33434
                </span>
              </div>
              <div className="flex items-center" data-id="element-34">
                <Phone className="h-5 w-5 mr-3 text-pts-red flex-shrink-0" data-id="element-35" />
                <a href="tel:8882188647" className="hover:text-white transition-colors font-bold" data-id="element-36">
                  888.218.8647
                </a>
              </div>
              <div className="flex items-start" data-id="element-37">
                <Mail className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-38" />
                <div className="flex flex-col" data-id="element-39">
                  <a href="mailto:savemoney@getcustomuniforms.com" className="hover:text-white transition-colors break-all" data-id="element-40">
                    savemoney@getcustomuniforms.com
                  </a>
                  <a href="mailto:support@getcustomuniforms.com" className="hover:text-white transition-colors break-all" data-id="element-41">
                    support@getcustomuniforms.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-42">
                <Clock className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-43" />
                <span data-id="element-44">
                  Monday – Friday
                  <br data-id="element-45" />
                  9am – 7pm EST
                </span>
              </div>
            </div>
          </div>

          {/* Sports */}
          <div data-id="element-46">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-47">
              Sports
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-48">
              <li data-id="element-49">
                <Link to="/sports/baseball" className="hover:text-pts-red transition-colors" data-id="element-50">
                  Baseball
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/sports/basketball" className="hover:text-pts-red transition-colors" data-id="element-52">
                  Basketball
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/sports/football" className="hover:text-pts-red transition-colors" data-id="element-54">
                  Football
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/sports/softball" className="hover:text-pts-red transition-colors" data-id="element-56">
                  Softball
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/sports/soccer" className="hover:text-pts-red transition-colors" data-id="element-58">
                  Soccer
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/sports/cheer" className="hover:text-pts-red transition-colors" data-id="element-60">
                  Cheer
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/sports/volleyball" className="hover:text-pts-red transition-colors" data-id="element-62">
                  Volleyball
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/sports/track-field" className="hover:text-pts-red transition-colors" data-id="element-64">
                  Track & Field
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-65">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-66">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-67">
              <li data-id="element-68">
                <Link to="/wholesale" className="hover:text-pts-red transition-colors" data-id="element-69">
                  Wholesale
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/mockup-request" className="hover:text-pts-red transition-colors" data-id="element-71">
                  Start Art Mockups
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/team-stores" className="hover:text-pts-red transition-colors" data-id="element-73">
                  Team Stores
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/process" className="hover:text-pts-red transition-colors" data-id="element-75">
                  Our Process
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/about" className="hover:text-pts-red transition-colors" data-id="element-77">
                  About Us
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/contact" className="hover:text-pts-red transition-colors" data-id="element-79">
                  Contact
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/get-started" className="hover:text-pts-red transition-colors font-bold text-white" data-id="element-81">
                  Start an Order
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/my-account" className="hover:text-pts-red transition-colors" data-id="element-83">
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-84">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-85">
              Connect
            </h4>
            <div className="flex space-x-4 mb-8" data-id="element-86">
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-87">
                <Facebook className="h-5 w-5" data-id="element-88" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-89">
                <Instagram className="h-5 w-5" data-id="element-90" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-91">
                <Twitter className="h-5 w-5" data-id="element-92" />
              </a>
            </div>

            <div className="bg-gray-800 p-5 rounded border border-gray-700" data-id="element-93">
              <h5 className="text-white font-bold mb-2" data-id="element-94">Have a Quote?</h5>
              <p className="text-sm text-gray-400 mb-4" data-id="element-95">
                Send it to us and we'll help you compare. Factory-direct
                pricing, fast turn times, and USA-based support.
              </p>
              <Link to="/contact" className="inline-block border border-pts-red text-pts-red hover:bg-pts-red hover:text-white px-4 py-2 rounded text-sm font-bold transition-colors w-full text-center" data-id="element-96">
                Send Your Quote
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-97">
          <div className="flex flex-col items-center md:items-start" data-id="element-98">
            <p className="mb-2" data-id="element-99">
              &copy; {new Date().getFullYear()} Primetime Sports Apparel. All
              rights reserved.
            </p>
            <p data-id="element-100">
              Interested in wholesale?{' '}
              <Link to="/wholesale" className="text-pts-red hover:text-white transition-colors" data-id="element-101">
                Request Wholesale Info.
              </Link>
            </p>
          </div>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-102">
            <Link to="/privacy" className="hover:text-gray-300" data-id="element-103">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gray-300" data-id="element-104">
              Terms of Service
            </Link>
            <Link to="/wholesale" className="hover:text-gray-300" data-id="element-105">
              Wholesale
            </Link>
          </div>
        </div>
      </Container>
    </footer>;
}